// extracted by mini-css-extract-plugin
module.exports = {"cursor":"cursor_cursor__O9jZm","zoomIn":"cursor_zoomIn__fRqMU","zoomOut":"cursor_zoomOut__MX2R_","showCursor":"cursor_showCursor__9x7ZQ"};